export type ReportsListViewMode = "board" | "table";

const STORAGE_KEY = "reports_list_view_mode_v1";

export function readReportsListViewMode(): ReportsListViewMode {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === "board" || raw === "table") return raw;
  } catch {
    // no-op
  }
  return "board";
}

export function writeReportsListViewMode(mode: ReportsListViewMode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // no-op
  }
}
